import BackGuide from '../../components/backGuide'
export default {
    install: function (Vue) {
        Vue.component('BackGuide',BackGuide)
    }
}



// WEBPACK FOOTER //
// ./src/plugins/backGuide/index.js